import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import StorePaymentMethods$1 from './StorePaymentMethods.js';

const StorePaymentMethodsContainer = (_param)=>{
    var { logos , paymentMethods  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "logos",
        "paymentMethods"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.paymentMethods.title')
        })
    , [
        getLabel
    ]);
    const items = React__default.useMemo(()=>{
        return paymentMethods.map(({ code  })=>{
            var ref;
            const logo = logos === null || logos === void 0 ? void 0 : logos.find(({ key  })=>key === code
            );
            if (!logo) {
                return null;
            }
            return {
                name: logo.displayName,
                iconUrl: (ref = logo.logo) === null || ref === void 0 ? void 0 : ref.url
            };
        }).filter((item)=>item !== null
        );
    }, [
        paymentMethods,
        logos
    ]);
    return items.length > 0 ? /*#__PURE__*/ React__default.createElement(StorePaymentMethods$1, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    })) : null;
};
var StorePaymentMethods = StorePaymentMethodsContainer;

export { StorePaymentMethods as default };
//# sourceMappingURL=StorePaymentMethodsContainer.js.map
